// @flow

import facets, { TYPE_TERM, TYPE_RANGE, facetMap } from './facets';
import selectorByPdbProperty from './selectorByPdbProperty';
import sortOptions, { type SortOptions, getDefaultSortOption, defaultSortOption } from './sortOptions';

const TYPE_CUSTOM = 'custom';
const TYPE_CAMPAIGN = 'campaign';

export {
  defaultSortOption,
  facets,
  getDefaultSortOption,
  selectorByPdbProperty,
  sortOptions,
  TYPE_TERM,
  TYPE_RANGE,
  TYPE_CUSTOM,
  TYPE_CAMPAIGN,
  facetMap,
};

export type {
  SortOptions,
};

export default null;
